<nav class="navbar navbar-expand-lg navbar-light" style="background-color: #f5573e!important;">
    <ul class="navbar-nav w-100 text-center">
        <li class="nav-item flex-fill">
            <a routerLink="/add-user" routerLinkActive="active" class="nav-link custom-tab"> <i
                    class="fa fa-user-plus mr-3"></i> Add New User</a>
        </li>
        <li class="nav-item flex-fill">
            <a routerLink="/user-list" routerLinkActive="active" class="nav-link custom-tab"> <i
                    class="fa fa-users mr-3"></i>User List</a>
        </li>
    </ul>
</nav>



<div class="container h-100 ">
    <div class="row h-100 justify-content-center align-items-center">
        <div class="col-10 col-md-6 col-lg-6">

            <form [formGroup]="userForm" class="p-5 bg-white shadow rounded" (ngSubmit)="addUser()">
                <div class="card-header text-white text-center">
                    <h4 class="mb-0" style="font: 500 29px / 4px Roboto, sans-serif;">User Registration</h4>
                </div>
                <div class="form-group">
                    <label for="username">Username</label>
                    <input id="username" type="text" formControlName="username" class="form-control"
                        placeholder="Enter Username">
                </div>

                <div class="form-group">
                    <label for="password">Password</label>
                    <input id="password" type="password" formControlName="password" class="form-control"
                        placeholder="Enter Password">
                </div>

                <div class="form-group">
                    <label for="password">Mobile Number</label>
                    <input id="mobile" type="tel" formControlName="mobile" class="form-control"
                        placeholder="Enter Mobile Number">
                </div>

                <div class="form-group">
                    <label for="role">Role</label>
                    <select id="role" formControlName="role" class="form-control">
                        <option value="" disabled>Select a Role</option>
                        <option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</option>
                    </select>
                </div>

                <div class="form-group">
                    <label for="department">Department</label>
                    <select id="department" formControlName="department" class="form-control">
                        <option value="" disabled>Select a Department</option>
                        <option *ngFor="let dept of departments" [value]="dept.dep_id">{{ dept.dep_name }}</option>
                    </select>
                </div>

                <button type="submit" class="btn btn-block" [disabled]="userForm.invalid"
                    style="background-color: #0086c1;color: black;">
                    Add User
                </button>
            </form>

        </div>
    </div>
</div>